import { render, staticRenderFns } from "./RoleResources.vue?vue&type=template&id=141c4d6d&"
import script from "./RoleResources.vue?vue&type=script&lang=js&"
export * from "./RoleResources.vue?vue&type=script&lang=js&"
import style0 from "./RoleResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports